import { render, staticRenderFns } from "./lkuCustomergroup.vue?vue&type=template&id=97d22fac"
import script from "./lkuCustomergroup.vue?vue&type=script&lang=js"
export * from "./lkuCustomergroup.vue?vue&type=script&lang=js"
import style0 from "./lkuCustomergroup.vue?vue&type=style&index=0&id=97d22fac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports